export default {
  MODAL_SEARCH_CAMPAIGNS: "CAMPAIGN_SEARCH/SEARCH",
  MODAL_SELECT_CATEGORY: "CAMPAIGN_SEARCH/CATEGORY",
  MODAL_UPDATE_QUERY_STRING: "CAMPAIGN_SEARCH/UPDATE_QUERY",
  MODAL_DEFINITELY_STOP_LOADER: "CAMPAIGN_SEARCH/STOP_LOADER",
  MODAL_START_LOADER: "CAMPAIGN_SEARCH/START_LOADER",
  MODAL_RESET_STATE: "CAMPAIGN_SEARCH/RESET_STATE",
  MODAL_SUBMIT_ERROR: "CAMPAIGN_SEARCH/SUBMIT_ERROR",
};

export const MINIMUM_WAIT_FOR_RESPONSE = 1000;
export const WAIT_TO_SHOW_CONTENT = 750;
export const PAGE_LIMIT = 12;
